import { useEffect, useState } from 'react'
import { Box, TextLink } from '@ui'
import { getJSON } from './api.js'

// Based on lb-wizard-demo's footer: which build is live (version, build number, build time, commit,
// branch if not master), then the Claude Code credit. The build number is the repo's commit count,
// the same counter as the app's build number. (A "deployed" time was dropped 2026-10-05: with
// scale-to-zero it was really the machine's last wake-up, which looked like a fresh deploy.) /api/build is public, so it shows
// before sign-in too. The Credits/Privacy/Terms links are public pages (the app links to them). A local `go run` has no commit or build date and shows "dev build".
export default function AppFooter() {
  const [build, setBuild] = useState(null)

  useEffect(() => {
    getJSON('/api/build').then(setBuild).catch(() => {})
  }, [])

  const fmt = (iso) => (iso
    ? new Date(iso).toLocaleString('en-GB', { timeZone: 'Europe/London', dateStyle: 'short', timeStyle: 'short' })
    : null)
  const isDev = build && !build.build_date && !build.git_commit
  const parts = build
    ? [
        `v${build.version}`,
        isDev ? 'dev build' : null,
        build.build_number ? `build ${build.build_number}` : null,
        !isDev && build.build_date ? `built ${fmt(build.build_date)}` : null,
        build.git_commit || null,
        build.git_branch && build.git_branch !== 'master' ? build.git_branch : null,
      ].filter(Boolean)
    : []

  return (
    <Box as="footer" textAlign="center" muted text="small" py={3} mt={4} borderTop>
      {parts.join(' · ')}
      <Box mt={1}>
        Built with{' '}
        <TextLink muted href="https://claude.ai/code" target="_blank" rel="noreferrer">
          Claude Code
        </TextLink>
      </Box>
      <Box mt={1}>
        <TextLink muted to="/credits">Credits</TextLink>
        {' · '}
        <TextLink muted to="/privacy">Privacy</TextLink>
        {' · '}
        <TextLink muted to="/terms">Terms</TextLink>
      </Box>
    </Box>
  )
}
